import { parse } from 'date-fns';
import { IntlShape } from 'react-intl';

import { FormatterValue, PlaceholderFormatter } from './types';

export const valueToString = (value: FormatterValue) => value?.toString() ?? '';

const timeToString = (formatTime: IntlShape['formatTime']) => (time: string) => {
  try {
    return formatTime(parse(time, 'HH:mm', new Date()));
  } catch (error) {
    return '';
  }
};

const localizedKeyToString = (formatMessage: IntlShape['formatMessage']) => (id: string) =>
  formatMessage({ id });

export const buildFormattersMap = (
  formatters: IntlShape,
  formatCurrencyForLocale: (amount: number) => string
) => ({
  [PlaceholderFormatter.CURRENCY]: formatCurrencyForLocale,
  [PlaceholderFormatter.DATE]: formatters.formatDate,
  [PlaceholderFormatter.LOCALIZED]: localizedKeyToString(formatters.formatMessage),
  [PlaceholderFormatter.TO_STRING]: valueToString,
  [PlaceholderFormatter.TIME]: timeToString(formatters.formatTime),
});
